import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Keep existing global styles
// import './styles/dreamchanted.css'; // Remove the import for the deleted file
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css'; 
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';

// Import Pacifico font for MagicalTitle
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css2?family=Pacifico&display=swap';
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById('root'));
// Removed StrictMode to prevent double rendering
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
